import React, { Component } from "react";
import LinkPdf from '../tools/LinkPdf'

class Manual extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <>
                <section id="insideDoc">
                    <h2>Manuel du formateur</h2>
                    <ul className="descarga">
                        <LinkPdf link="http://fundacioncanguro.co/ebooks/fr/manual" titulo="Interactive ebook" pdf={process.env.PUBLIC_URL + '/manual/manual.pdf'} />
                    </ul>
                </section>
            </>
        )
    }
}

export default Manual;